import React from "react";
// import Link from "@material-ui/core/Link";
import firebase from "firebase";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { blue } from "@material-ui/core/colors";
import Paper from "@material-ui/core/Paper";
import Title from "../Title";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
// import { withState } from "recompose";
import { CSVLink } from "react-csv";
import TextField from "@material-ui/core/TextField";

//Confirm Modal
const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  dlgHeader: {
    textAlign: "center",
  },
  dlgButtons: {
    display: "flex",
    marginTop: "30px",
    padding: "10px",
  },
  dlgButton: {
    padding: "5px",
  },
  export: {
    color: "#3f51b5",
    fontSize: "20px",
    textDecoration: "none",
  },
  exportContainer: {
    backgroundColor: "white",
    borderRadius: "5px",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    color: "#3f51b5",
    cursor: "pointer",
    marginTop: "-30px",
    marginBottom: "20px",
    width: "150px",
    height: "45px",
    "&:active": {
      backgroundColor: "#3f51b5",
      "& a": {
        color: "white",
      },
      "& div": {
        color: "white",
      },
    },
  },
  search: {
    backgroundColor: "white",
    borderRadius: "3px",
    display: "flex",
    color: "black",
    marginBottom: "20px",
  },
  searchIcon: {
    padding: "10px",
  },
  title: {
    width: "500px",
    padding: "5px 20px 20px 20px",
    "& input": {
      borderBottom: "1px solid grey",
      "&:hover": {
        borderBottom: "2px solid black",
      },
      "&:focus": {
        borderBottom: "2px solid #3f51b5",
      },
    },
  },
});
//Notification Modal
function NotificationModal(props) {
  const classes = useStyles();
  const [body, setBody] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [notification, setNotification] = React.useState("");
  const { onClose, open, handleNotify } = props;
  const data = {
    title: "",
    // icon: "",
    body: "",
    url: "",
  };

  const handleInputChange = (e) => {
    setTitle(e.target.value);
    data.title = e.target.value;
    data.body = body;
    data.url = url;
    setNotification(data);
  };

  const handleUrlChange = (e) => {
    setUrl(e.target.value);
    data.title = title;
    data.body = body;
    data.url = e.target.value;
    setNotification(data);
  };

  const handleInputText = (e) => {
    setBody(e.target.value);
    data.title = title;
    data.body = e.target.value;
    data.url = url;
    setNotification(data);
  };

  const handleClose = () => {
    setBody("");
    setTitle("");
    setUrl("");
    onClose();
  };

  const handleClickSend = () => {
    handleNotify(notification);
    setBody("");
    setTitle("");
    setUrl("");
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dlgHeader}>
        Input your text
      </DialogTitle>
      <label style={{ fontWeight: "600", paddingLeft: "20px" }}>Title</label>
      <InputBase
        placeholder="Input Notification Title"
        onChange={handleInputChange}
        value={title}
        className={classes.title}
      />
      <label style={{ fontWeight: "600", paddingLeft: "20px" }}>URL</label>
      <InputBase
        placeholder="Input Redirect URL"
        onChange={handleUrlChange}
        value={url}
        className={classes.title}
      />
      <label style={{ fontWeight: "600", paddingLeft: "20px" }}>Content</label>
      <TextField
        id="standard-multiline-flexible"
        multiline
        rowsMax={4}
        value={body}
        onChange={handleInputText}
        placeholder="Input Notification Content"
        style={{ width: "500px", padding: "5px 20px 20px 20px" }}
      />
      <Button onClick={handleClickSend} style={{ width: "500px" }}>
        SEND
      </Button>
    </Dialog>
  );
}

NotificationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

//Confirm Modal
function ConfirmModal(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(false);
  };

  const handleClickYes = () => {
    var db = firebase.firestore();
    db.collection("users")
      .doc(selectedValue)
      .get()
      .then((doc) => {
        doc.ref.delete();
        onClose(true);
      });
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dlgHeader}>
        Do you want to remove this user? <br />
        <br />
        {selectedValue}
      </DialogTitle>
      <div className={classes.dlgButtons}>
        <Button className={classes.dlgButton} onClick={handleClickYes}>
          YES
        </Button>
        <Button className={classes.dlgButton} onClick={handleClose}>
          NO
        </Button>
      </div>
    </Dialog>
  );
}

ConfirmModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

//Batch delete confirm modal
//Confirm Modal
function DeleteModal(props) {
  const classes = useStyles();
  const { onClose, open, handleDelete } = props;

  const handleClose = () => {
    onClose();
  };

  const handleClickYes = async () => {
    await handleDelete();
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dlgHeader}>
        Do you want to delete selected users? <br />
        <br />
      </DialogTitle>
      <div className={classes.dlgButtons}>
        <Button className={classes.dlgButton} onClick={handleClickYes}>
          YES
        </Button>
        <Button className={classes.dlgButton} onClick={handleClose}>
          NO
        </Button>
      </div>
    </Dialog>
  );
}

DeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

// Generate Recent Data
function createData(
  id,
  lastPlayed,
  name,
  email,
  nickName,
  maxScore,
  lastScore,
  notification,
  token,
  lastStatus
) {
  return {
    id,
    lastPlayed,
    name,
    email,
    nickName,
    maxScore,
    lastScore,
    notification,
    token,
    lastStatus,
  };
}

// function preventDefault(event) {
//   event.preventDefault();
// }

export default function Users() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [isDelete, setDelete] = React.useState(false);
  const [openNotify, setOpenNotify] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [inputvalue, setValue] = React.useState("");
  const [tokens, setToken] = React.useState([]);
  const [checkedItems, setCheckedItems] = React.useState(new Map());

  React.useEffect(() => {
    getUserData();
  }, []);

  const handleChange = (event) => {
    let rows = [];
    const db = firebase.firestore();
    var i = 0;
    db.collection("users")
      .where("email", ">=", event.target.value)
      .where("email", "<", event.target.value + "z")
      // .orderBy("score", "desc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var date = doc.data().lastTime;
          var d = new Date(date);
          var ds = d.toString();
          var notification = doc.data().notify ? "On" : "Off";
          rows[i] = createData(
            i,
            ds,
            doc.data().name,
            doc.data().email,
            doc.data().nickName,
            doc.data().score,
            doc.data().lastScore,
            notification,
            doc.data().token,
            doc.data().lastStatus
          );
          i++;
        });
        setRows(rows);
      });
    setValue(event.target.value);
  };

  function getUserData() {
    let rows = [];
    const db = firebase.firestore();
    var i = 0;
    db.collection("users")
      .where("type", "==", "h")
      // .orderBy("score", "desc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var date = doc.data().lastTime;
          var d = new Date(date);
          var ds = d.toString();
          var notification = doc.data().notify ? "On" : "Off";
          rows[i] = createData(
            i,
            ds,
            doc.data().name,
            doc.data().email,
            doc.data().nickName,
            doc.data().score,
            doc.data().lastScore,
            notification,
            doc.data().token,
            doc.data().lastStatus
          );
          i++;
        });
        setRows(rows);
      });
  }

  const handleClickRemove = (email) => {
    setSelectedValue(email);
    setOpen(true);
  };

  const handleCloseModal = (value) => {
    setOpen(false);
    if (value === true) {
      getUserData();
      setSelectedValue("");
    }
  };

  const handleClickDelete = () => {
    setDelete(true);
  };

  const handleDelete = () => {
    rows.map((row, i) => {
      if (checkedItems.get(row.email)) {
        const db = firebase.firestore();
        db.collection("users")
          .doc(row.email)
          .get()
          .then((doc) => {
            doc.ref.delete();
          });
      }
      return true;
    });
  };

  const handleClose = async () => {
    await getUserData();
    setDelete(false);
  };

  const handleClickNotify = () => {
    let temp = [];
    let count = 0;
    rows.map((row, i) => {
      if (checkedItems.get(row.email)) {
        temp[count] = row.token;
        count++;
      }
    });
    setToken(temp);
    setOpenNotify(true);
  };

  const handleCloseNotify = () => {
    setOpenNotify(false);
  };

  const handleNotify = (data) => {
    tokens.map(async function (token) {
      const response = await fetch("https://fcm.googleapis.com/fcm/send", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "key=AAAArHUrVMU:APA91bHYrSAPUiKf5Z2ycFlqMlhC8E1U80dVhTiUFtgvOeOu3M5WtmK-vpZw17xqxPxEtSiLB5z6FLAi_HXS_H9lo2A_TD9vJ7CAL2q974JSRTcB6W1sPQsLsqP7k9jkUBM3gtGtNpfl",
        },
        body: JSON.stringify({
          data: {
            message: data.title,
            body: data.body,
            icon:
              "https://firebasestorage.googleapis.com/v0/b/lucky7-engine.appspot.com/o/avatars%2F0.svg?alt=media&token=68b01671-45fc-45a2-bf68-ee0215922066",
            url: data.url,
          },
          to: token,
        }),
      });
      return true;
    });
  };

  const handleChecked = React.useCallback(({ target: { name, checked } }) => {
    setCheckedItems((prevState) => {
      return new Map(prevState).set(name, checked);
    });
  }, []);

  const handleCheckAll = (e) => {
    let items = new Map();
    rows.map((row) => {
      if (e.target.checked) items.set(row.email, true);
      else items.set(row.email, false);
    });
    setCheckedItems(items);
  };

  return (
    <React.Fragment>
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search by Email…"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          inputProps={{ "aria-label": "search" }}
          onChange={handleChange}
          value={inputvalue}
        />
      </div>
      <Paper>
        <Title>Users List</Title>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: " 0 10px 0 10px",
          }}
        >
          <div className={classes.exportContainer}>
            <CSVLink
              data={rows}
              className={classes.export}
              filename={"user-list.csv"}
            >
              Export
            </CSVLink>
          </div>
          <div className={classes.exportContainer} onClick={handleClickNotify}>
            <div className={classes.export} style={{ marginTop: "8px" }}>
              Notify
            </div>
          </div>
          <div className={classes.exportContainer} onClick={handleClickDelete}>
            <div className={classes.export} style={{ marginTop: "8px" }}>
              Delete Selected
            </div>
          </div>
        </div>
        <Table size="medium">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>NickName</TableCell>
              <TableCell>MaxScore</TableCell>
              <TableCell>LastScore</TableCell>
              <TableCell>LastPlayed</TableCell>
              <TableCell>LastStatus</TableCell>
              <TableCell>Remove</TableCell>
              <TableCell align="right">
                <input
                  type="checkbox"
                  style={{ width: "20px", height: "20px" }}
                  onChange={handleCheckAll}
                ></input>
              </TableCell>
              {/* <TableCell align="right">Notification</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.nickName}</TableCell>
                <TableCell>{row.maxScore}</TableCell>
                <TableCell>{row.lastScore}</TableCell>
                <TableCell>{row.lastPlayed}</TableCell>
                <TableCell>
                  {row.lastStatus === "lucky" ? (
                    <img
                      alt="lucky"
                      src={require("../../../assets/images/luck.svg")}
                    ></img>
                  ) : (
                    <img
                      alt="unlucky"
                      src={require("../../../assets/images/unluck.svg")}
                    ></img>
                  )}
                </TableCell>
                {/* <TableCell align="right">{row.notification}</TableCell> */}
                <TableCell>
                  <DeleteIcon
                    style={{
                      marginLeft: "20px",
                      marginRight: "20px",
                    }}
                    onClick={() => handleClickRemove(row.email)}
                  />
                </TableCell>
                <TableCell>
                  <input
                    name={row.email}
                    type="checkbox"
                    style={{ width: "20px", height: "20px" }}
                    // onChange={(e) => handleChecked(e, row.token)}
                    onChange={handleChecked}
                    // onClick={handleClickCheckbox}
                    // defaultChecked={checked}
                    checked={checkedItems.get(row.email)}
                  ></input>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {/* <Button className={classes.export}>Export</Button> */}
        <NotificationModal
          open={openNotify}
          onClose={handleCloseNotify}
          handleNotify={handleNotify}
        />
        <ConfirmModal
          open={open}
          onClose={handleCloseModal}
          selectedValue={selectedValue}
        />
        <DeleteModal
          open={isDelete}
          onClose={handleClose}
          data={rows}
          handleDelete={handleDelete}
        />
      </Paper>
    </React.Fragment>
  );
}
